import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mh-movies-area ptb-100" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "mh-movies-card" }
const _hoisted_4 = { class: "image" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "number" }
const _hoisted_7 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mh-movies-title" }, [
        _createElementVNode("h5", { class: "text-white" }, "أبرز الباقات والمحتوى المتوفر اليوم")
      ], -1)),
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.mh-movies-pagination',
          clickable: true,
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          992: { slidesPerView: 5 },
          1200: { slidesPerView: 5 },
        },
        modules: _ctx.modules,
        class: "mh-movies-slider"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movies, (movie, index) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: movie.image,
                      alt: movie.title
                    }, null, 8, _hoisted_5),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(index + 1), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h3", null, _toDisplayString(movie.title), 1),
                    _cache[0] || (_cache[0] = _createElementVNode("a", {
                      href: "https://wa.me/447429916178",
                      target: "_blank",
                      class: "link-btn"
                    }, [
                      _createTextVNode(" تفاصيل الباقة "),
                      _createElementVNode("i", { class: "ti ti-arrow-left" })
                    ], -1))
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mh-movies-pagination" }, null, -1))
    ])
  ]))
}